import Photo from '../photo/Photo.vue';

export default {
  name: 'ProjectingForm',
  components: { Photo },
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      // v-model для формы
      valid: false,
      form: {
        id: 0,
        address: '',
        house_size: '',
        technical_specifications: '',
        types_work: '',
        architectural_plans: [],
        question_1: '',
        question_2: '',
        question_3: '',
        question_4: '',
        check: [],
      },
      submitIsProcessing: false,
      // Правила валидации формы
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
      },
      searchAddress: '',
      addresses: [],
      loading: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    // Отображать ли кнопку "Сохранить черновик"?
    isShowDraftButton() {
      return (
        !this.item?.id
        || this.item?.status === 'draft'
      );
    },
    showCheckFile() {
      return this.item?.status === 'project_ready';
    },
  },
  watch: {
    searchAddress(val) {
      if (!val) {
        this.addresses = [];
        return;
      }
      this.loading = true;
      this.$store.getters.axl.post('profiles/api/profiles/autocomplete-address', { term: val })
        .then((result) => {
          this.addresses = result.data.addresses;
          this.loading = false;
        });
    },
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog');
    },
    /**
     * Метод добавления новой заявки
     */
    onSubmit(is_draft = false) {
      this.submitIsProcessing = true;
      const app = this;
      let restURL = 'design/api/application/create';

      if (app.form.id) {
        restURL = 'design/api/application/update';
      }

      delete app.form.created_at;

      // eslint-disable-next-line
      if (!is_draft && !app.valid) {
        app.$store.dispatch('ShowInfo', 'Не заполнены обязательные поля');
        this.submitIsProcessing = false;
        return;
      }

      const application = {
        ...app.form,
        is_draft,
        profile_id: this.user.profile_id,
      };

      app.$store.getters.axl
        .post(restURL, application)
        .then((result) => {
          app.dialog = false;
          app.$store.dispatch('design/ProjectingGetView', {
            profile_id: app.user.profile_id,
            application_id: result.data.application.id,
          });
          app.$store.dispatch('design/ProjectingGetList', {
            profile_id: app.user.profile_id,
          });
          app.form = {
            address: '',
            house_size: '',
            technical_specifications: '',
            types_work: '',
            architectural_plans: [],
            question_1: '',
            question_2: '',
            question_3: '',
            question_4: '',
            check: [],
          };
          this.$refs.form.resetValidation();
          app.closeDialog();
          // eslint-disable-next-line
          const msg = is_draft ? 'Заявка сохранена в черновик' : 'Заявка отправлена на проверку';
          app.$store.dispatch('ShowInfo', msg);
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        }).finally(() => {
          app.submitIsProcessing = false;
        });
    },
  },
  mounted() {
    this.$store.dispatch('SetTitle', 'Проектирование');
    if (this.item) {
      this.form = this.item;
      this.searchAddress = this.form.address;
    }
  },
};
